import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Content } from 'ionic-angular';
import { VisitorProvider } from '../../providers/visitor/visitor';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';


@IonicPage()
@Component({
  selector: 'page-visit-detail',
  templateUrl: 'visit-detail.html',
})
export class VisitDetailPage {

  @ViewChild(Content) content: Content;

  visit: any;
  active: boolean = false;
  showAD: boolean = false;
  showAne: boolean = false;
  showTime: boolean = false;
  status = {};
  timeOptions = [0.5, 1, 2];

  constructor(public navCtrl: NavController, public navParams: NavParams,private translate: TranslateService, private visitorProvider: VisitorProvider, private toast: ToastProvider) {
    let visit = this.navParams.data;
    if(visit.end_time == "0000-00-00 00:00:00"){
      visit.end_time = null;
    }
    if(visit.allow == null && visit.end_time == null && visit.attended == null) {
      this.showAD = true;
      this.showTime = true;
    }
    if(visit.attended == null && visit.allow != 0){
      this.showAne = true;
      this.showTime = true;
    }
    this.visit = visit;
    this.setStatus();
  }

  activate(){
    this.active = !this.active;
  }

  setStatus(){
    if(this.visit.attended == null){
      if(this.visit.allow != null){
        if(this.visit.allow){
          this.status = {name: "Allowed", color: "success"};
        }else{
          this.status = {name: "Denied", color: "danger"};
        }
      }
    }else{
      if(this.visit.attended){
        this.status = {name: "Attended", color: "success"};
      }else{
        this.status = {name: "Not visited", color: "danger"};
      }
    }
  }

  extendTime(time: number){
    let visit = this.visit;
    visit.time = time;
    this.visitorProvider.extendTime(visit).then(val => {
      if(val.status == "success"){
        this.visit.allowed_time = +this.visit.allowed_time + time;
        this.toast.presentToast("Time extended by: " + time);
      }else{
        this.toast.presentToast(val.message);
      }
    });
  }

  onAllow(){
    this.visitorProvider.allow(this.visit).then(val => {
      if(val.status == "success"){
        this.toast.presentToast("Allowed");
        this.showAD = false;
        this.visit.allow = 1;
        this.status = {name: "Allowed", color: "success"};
      }else{
        this.toast.presentToast(val.message);
      }
    });
  }

  onDeny(){
    this.visitorProvider.deny(this.visit).then(val => {
      if(val.status == "success"){
        this.toast.presentToast("Denied")
        this.showAD = false;
        this.showAne = false;
        this.showTime = false;
        this.visit.allow = 0;
        this.status = {name: "Denied", color: "danger"};
      }else{
        this.toast.presentToast(val.message);
      }
    });
  }

  onAne(){
    this.visitorProvider.ane(this.visit).then(val => {
      if(val.status == "success"){
        this.toast.presentToast("Attended & Exit");
        this.showAne = false;
        this.showAD = false;  
        this.showTime = false;
        this.visit.attended = 1;
        this.status = {name: "Attended", color: "success"};
      }else{
        this.toast.presentToast(val.message);
      }
    });
  }

  onNv(){
    this.visitorProvider.nv(this.visit).then(val => {
      if(val.status == "success"){
        this.toast.presentToast("Set as not visited");
        this.showAne = false;
        this.showAD = false;  
        this.showTime = false;
        this.visit.attended = 0;
        this.status = {name: "Not visited", color: "danger"};
      }else{
        this.toast.presentToast(val.message);
      }
    });
  }

  makeGenericData(data) {
    var type = typeof (data);
    if (type == 'number' && (data == 1 || data == 0)) {
      return data ? 'Yes' : 'no'
    } else {
      return data
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/visit-detail/visit-detail.ts